import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';

import { CrmPageBuilder } from '@anyx/function-chat/shared';

export const AdminSectionTemplate = () => {
  const { t } = useTranslation(['anychat', 'shared']);
  const pageTitle = t('shared.entity.adminSection', { ns: 'shared', count: 2 });

  return (
    <CrmPageBuilder.Root responsive={false} center className="max-w-5xl px-4">
      <CrmPageBuilder.DocumentHead pageTitle={pageTitle} />
      <CrmPageBuilder.Title text={pageTitle} />
      <CrmPageBuilder.Content>
        <Outlet />
      </CrmPageBuilder.Content>
    </CrmPageBuilder.Root>
  );
};
